import { defineStore } from 'pinia'
import axios from '../config/api.js'

export const useAnalyticsStore = defineStore('analytics', {
  state: () => ({
    dataPoints: [],
    loading: false,
    error: null,
    filters: {
      from: '',
      to: '',
      emailAccountId: null,
    },
  }),

  actions: {
    async fetchAnalytics(from, to, emailAccountId = null) {
      this.loading = true
      this.error = null
      this.filters = { from, to, emailAccountId }
      try {
        const params = { from, to }
        if (emailAccountId) params.emailAccountId = emailAccountId
        const response = await axios.get('/api/analytics', { params })
        this.dataPoints = response.data.dataPoints || []
        return { success: true }
      } catch (error) {
        this.error = error.response?.data?.error || 'Failed to load analytics data'
        return { success: false, message: this.error }
      } finally {
        this.loading = false
      }
    },

    async exportCsv(from, to, emailAccountId = null) {
      this.error = null
      try {
        const params = { from, to }
        if (emailAccountId) params.emailAccountId = emailAccountId
        const response = await axios.get('/api/analytics/export', {
          params,
          responseType: 'blob',
        })
        const url = URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `emailauto-analytics-${from}-${to}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        return { success: true }
      } catch (error) {
        this.error = error.response?.data?.error || 'Failed to export CSV'
        return { success: false, message: this.error }
      }
    },

    clearError() {
      this.error = null
    },
  },
})
